import React, { useEffect, useState } from 'react';
import VendorCard from '../VendorCard';
import axios from 'axios';
import ScrollableRow from '../../utils/ScrollableRow';

const VendorsRow = () => {

    const [sellers, setSellers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchSellers = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/sellers/latest`);
                setSellers(response.data.sellers);
            } catch (error) {
                console.error('Error fetching sellers:', error);
            }
            finally {
                setLoading(false);
            }
        };
        fetchSellers();
    }, []);

    const vendors = sellers?.map(seller => ({
        id: seller._id,
        imageSrc: seller.profileImage,
        name: seller.displayName || seller.fullName,
        description: seller.description,
        rating: seller.rating,
        totalReviews: seller.noOfReviews,
        location: `${seller.sellerAddress.city}, ${seller.sellerAddress.country?.name}`,
    }));

    return (
        <section className="vendorsSection">
            <section className="mainSection">
                <ScrollableRow
                    title="Our Top Vendors"
                    items={vendors}
                    itemsPerRow={4}
                    renderItem={(vendor, index) => <VendorCard key={index} vendor={vendor} />}
                    isLoading={loading}
                    noItemsMessage="No vendors available to show here."
                />
            </section>
        </section>
    );
};

export default VendorsRow;